export default __webpack_public_path__ + "static/media/skogafoss_overlook_iceland.d4e8f3f8.jpg";